import {
  ResourceNameWithPronouns,
  ResourceNameWithPronounsProps
} from 'v5/patterns/resource/ResourceNameWithPronouns';
import { myGlobalSettingsService } from 'v5/services/internal/GlobalSettingsService/GlobalSettingsService.connected';

const services = { globalSettingsService: myGlobalSettingsService };

export function ResourceNameWithPronounsConnected(
  props: Omit<ResourceNameWithPronounsProps, 'services'>
) {
  return <ResourceNameWithPronouns {...props} services={services} />;
}
